import React, { useEffect } from 'react'
import { Col, Modal, Row } from 'react-bootstrap'
import { KTSVG } from '../../../../../_metronic/helpers'
import { ConnectAndHealForm } from '../../../../modules/futurisk/ConnectAndHealForm'


type Props = {
  show: boolean
  handleClose: () => void
}

const ConnectAndHealModal: React.FC<Props> = ({ show, handleClose }) => {
  useEffect(() => {
    initMap()
  }, [])

  //const [location, setLocation] = useState(data.location)
  const dissmissLocation = () => {
    //setLocation(data.location)
    handleClose()
  }

  const initMap = () => { }

  return (
    <Modal
      className='modal fade'
      id='kt_modal_test'
      data-backdrop='static'
      tabIndex={-1}
      role='model'
      show={show}
      dialogClassName=' modal-dialog-scrollable'
      aria-hidden='true'
      onHide={dissmissLocation}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>Register With Seva at Home</h5>

          <div
            className='btn btn-icon btn-sm btn-active-light-primary ms-2'
            onClick={dissmissLocation}
          >
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-3x' />
          </div>
        </div>
        <div className='modal-body'>
          <Row>
            <Col xs={12} md={12}>
              <ConnectAndHealForm />
            </Col>
          </Row>
        </div>
        <div className='modal-footer'>
          * terms and conditions apply
        </div>
      </div>
    </Modal>
  )
}

export { ConnectAndHealModal }
